import { ImpactCo2AnswerStatsPublic } from '@/domain/impact-stats/entities/stats-public.entity';

import { useExtrapolation } from './useExtrapolation';

export function useExtrapolationAccommodation(
  statsPublic: ImpactCo2AnswerStatsPublic,
) {
  const personCount = statsPublic.publicAccommodationSumTotalGuestCount;
  return useExtrapolation(statsPublic, personCount, applyExtrapolation);
}

function applyExtrapolation(
  statsPublic: ImpactCo2AnswerStatsPublic,
  f: number,
): ImpactCo2AnswerStatsPublic {
  return {
    ...statsPublic,
    numberOfNights: Math.round(statsPublic.numberOfNights * f),
    publicAccommodationSumTotalGuestCount: Math.round(
      statsPublic.publicAccommodationSumTotalGuestCount * f,
    ),
    publicAccommodation: statsPublic.publicAccommodation.map((x) => ({
      ...x,
      totalGuestCount: Math.round(x.totalGuestCount * f),
      totalNumberOfNights: Math.round(x.totalNumberOfNights * f),
      totalScore: x.totalScore * f,
    })),
  };
}
